import { render, staticRenderFns } from "./PercentageBar.vue?vue&type=template&id=286c562a&scoped=true"
import script from "./PercentageBar.vue?vue&type=script&lang=js"
export * from "./PercentageBar.vue?vue&type=script&lang=js"
import style0 from "./PercentageBar.vue?vue&type=style&index=0&id=286c562a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286c562a",
  null
  
)

export default component.exports